import {
    LIKE_SECTION_POPUP_TOGGLE,
    LikeSectionPopupToggleAction,
} from 'mk2/apps/blogs/containers/LikeSection/LikeSection.actions';
import { tupdate } from 'mk2/helpers/types';
import { Reducer } from 'redux';

export interface LikeSectionState {
    showModal: boolean;
}

export const initialLikeSectionState: LikeSectionState = {
    showModal: false,
};

export interface LikeSectionsState {
    [entityTypeAndId: number]: LikeSectionState;
}

const initialLikeSectionsState: LikeSectionsState = {};

declare type LikeSectionsReducerAction = LikeSectionPopupToggleAction;

const likeSectionsReducer: Reducer<LikeSectionsState> = (
    state: LikeSectionsState = initialLikeSectionsState,
    action: LikeSectionsReducerAction,
) => {
    switch (action.type) {
        case LIKE_SECTION_POPUP_TOGGLE: {
            const key = `${action.entityType}/${action.entityId}`;

            return tupdate(state, {
                [key]: tupdate(state[key] || initialLikeSectionState, {
                    showModal: !(state[key] || initialLikeSectionState).showModal,
                }),
            });
        }

        default:
            return state;
    }
};

export default likeSectionsReducer;
